class AppStorage {
  public getBoolean(key: string, defaultValue: boolean): boolean {
    return localStorage.getItem(key) !== null ? !!localStorage.getItem(key) : defaultValue;
  }

  public getNumber(key: string, defaultValue: number): number {
    return Number(localStorage.getItem(key) || defaultValue);
  }

  public getString(key: string, defaultValue: string): string {
    return localStorage.getItem(key) || defaultValue;
  }

  public setBoolean(key: string, value: boolean): void {
    localStorage.setItem(key, value.toString());
  }

  public setNumber(key: string, value: number): void {
    localStorage.setItem(key, value.toString());
  }

  public setString(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public getKeys(): string[] {
    return Object.keys(localStorage);
  }
  public remove(key: string): void {
    localStorage.removeItem(key);
  }
}

export default new AppStorage();
